/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc
 */
import * as References from './SettingsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#getUserSettings
 */
export const GET_USER_SETTINGS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_getUserSettings';
export const GET_USER_SETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_SETTINGS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#updateUserSettings
 */
export const UPDATE_USER_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_updateUserSettings';
export const UPDATE_USER_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_USER_SETTINGS_MUTATION_FIELD_NAME,
  args: ['preferredLanguage', 'firstName', 'lastName', 'jobTitle', 'phone', 'company', 'address', 'city', 'state', 'zip', 'country', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateUserSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#uploadProfilePhoto
 */
export const UPLOAD_PROFILE_PHOTO_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_uploadProfilePhoto';
export const UPLOAD_PROFILE_PHOTO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPLOAD_PROFILE_PHOTO_MUTATION_FIELD_NAME,
  args: ['imageData', 'contentType', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.uploadProfilePhotoRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#changePassword
 */
export const CHANGE_PASSWORD_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_changePassword';
export const CHANGE_PASSWORD_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CHANGE_PASSWORD_MUTATION_FIELD_NAME,
  args: ['currentPassword', 'newPassword', 'newPasswordConfirm', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.changePasswordRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#getPasswordStatus
 */
export const GET_PASSWORD_STATUS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_getPasswordStatus';
export const GET_PASSWORD_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PASSWORD_STATUS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getPasswordStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc#createOrUpdatePassword
 */
export const CREATE_OR_UPDATE_PASSWORD_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SettingsRpc_createOrUpdatePassword';
export const CREATE_OR_UPDATE_PASSWORD_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_OR_UPDATE_PASSWORD_MUTATION_FIELD_NAME,
  args: ['currentPassword', 'newPassword', 'newPasswordConfirm', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.createOrUpdatePasswordRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});